export const rootUrl = "";
export const assetClassConfigUrl = "config/asset-classes";
export const assetCategoryConfigUrl = "config/asset-categories";
export const assetHealthConfigUrl = "config/asset-factors";
export const assetSizeConfigUrl = "config/asset-sizes";
export const assetInfoFieldConfigUrl = "config/asset-info-fields";
export const assetCategorySpatialConfigUrl = "config/spatial/asset-categories";
export const assetFactorUrl = "asset-factors";
export const assetSizeUrl = "asset-sizes";
export const snapshotUrl = "asset-snapshots";
export const snapshotWriteUrl = "request-write";
export const snapshotReadUrl = "request-read";
export const snapshotColumnUrl = "columns";
export const transformationRuleUrl = "transformation-rules";
export const calculationRuleUrl = "calculation-rules";
export const swapRequestUrl = "swap-request";
export const pullRequestUrl = "pull-request";
export const transformedDataUrl = "transformed-data";
export const modelUrl = "models";
export const builderUrl = "builder";
export const scenarioUrl = "scenarios";
export const mandatoryTreatmentUrl = "mandatory-treatments";
export const tagUrl = "tags";
export const jobUrl = "jobs";
export const runAllUrl = "run-all-request";
export const cancelAllUrl = "cancel-all-request";
export const resultsUrl = "results";
export const dataSeriesUrl = "data-series";
export const assetCategoriesUrl = "asset-categories";
export const publishRequestUrl = "publish-request";
export const dataUrl = "data";
export const dataCount = "data-count";
export const lifecycleTemplateUrl = "templates/lifecycle";
export const resourceUrl = "me/resources";
export const userUrl = "me";
export const loginUrl = "logins";
export const tenantUrl = "tenants";
export const domainsUrl = "domains";
export const settingsUrl = "settings";
export const idpConfigUrl = "saml/idp-metadata";
export const samlSpMetadataUrl = "saml/sp-metadata";
export const portfolioUrl = "portfolios";
export const memberUrl = "members";
export const planUrl = "plans";
export const planAttributesUrl = "attributes";
export const planDocumentUrl = "plan-documents";
export const planDocumentCreateUrl = "plan-documents/create-request";
export const planDocumentPreviewUrl = "plan-documents/preview-request";
export const downloadRequestUrl = "download-request";
export const tenantHealthBinUrl = "config/health-bins";
export const assetCategoryHealthBinUrl = "config/asset-categories/health-bins";
export const healthBinUrl = "health-bins";
export const subscriptionUrl = "subscription";
export const billingUrl = "billing";
export const customerPortalUrl = "customer-portal";
export const featuresUrl = "features";
export const limitsUrl = "limits";
export const modelSummaryUrl = "model-summaries";
export const spatialUrl = "spatial";
export const compressionExportUrl = "compression-export";
export const reportUrl = "reports";
export const entityUrl = "entities";
export const histogramUrl = "histogram";
export const infoUrl = "info";
export const entityReportUrl = "entity-reports";
export const exportUrl = "export";
export const digitalPlanUrl = "digital-plans";
export const artifactsUrl = "artifacts";
export const storyboardUrl = "storyboards";
export const configurationsUrl = "configurations";
export const entityConfigUrl = "entity";
export const gapIndexUrl = "gap-index";
export const narrativeUrl = "narratives";
export const promptResponseUrl = "prompt-response";
export const generateNarrativeRequest = "generate-response-request";
export const auditLogsUrl = "audit-logs";
export const auditLogInfoUrl = "audit-logs/info";
export const connectorsUrl = "connectors";
export const resourcesUrl = "resources";
export const verifyUrl = "verify";
export const snapshotColumnSuggestionsUrl = "column-suggestions";
export const dynamicUrl = "dynamic";
export const dataRequestUrl = "data-request";
